const { ccclass, property } = cc._decorator;
import ViewBase from "../../../../../framework/core/mvvm/view_base";
import { ListView, ListViewDir } from "../../../../../framework/tools/scrollview/listview";
import Utility from "../../../../../utility/utility";
import ModelData, { IUserData } from "../../../../public/model_data";

import GoldRoomItem from "./gold_room_item";
import GameUtil from "../../../../../utility/game_util";
import LanguageManager from '../../../../../manager/language_manager';
import AppData from "../../../../public/const/app_data";
import MarqueeComponent from "../../marquee/marquee_component";
import SpriteFrameHolder from "../../../../public/ui/spriteFrameHolder";
import { PlayerInfo } from "../../hall/hall_view";
import { ProtoHallServerNotify } from "../../../server/hallnotify/proto_hall_gameserver_notify";
import { IUserCurrencyData } from "../../../../../manager/user_manager";


@ccclass
export default class GoldEntranceView extends ViewBase {
    @property(PlayerInfo)
    playerInfo: PlayerInfo = new PlayerInfo()
    @property(cc.Node)
    bgNode: cc.Node = null;
    @property(cc.ScrollView)
    scrollview: cc.ScrollView[] = [];

    @property(cc.Node)
    view: cc.Node[] = [];

    @property(cc.Node)
    content: cc.Node[] = [];

    @property(cc.Node)
    prefab: cc.Node[] = [];
    // @property(cc.Toggle)
    // toggleFemale: cc.Toggle = null;
    @property(cc.Node)
    chip: cc.Node = null;
    @property(cc.Node)
    mango: cc.Node = null;
    @property(cc.Label)
    coinDes: cc.Label = null;
    m_list: ListView[] = []
    @property(cc.Node)
    titleList: cc.Node[] = [];
    itemList: {} = {}

    @property(cc.Node)
    top: cc.Node = null;
    @property(cc.Node)
    rightNode: cc.Node = null;

    @property(cc.Label)
    minLimit: cc.Label = null // 下限
    @property(cc.Label)
    jackpot: cc.Label = null // 彩池
    // @property(cc.Toggle)
    // toggleList: cc.Toggle[] = [];

    // @property(cc.Toggle)
    // hideToggle: cc.Toggle = null;

    @property(MarqueeComponent)
    marquee: MarqueeComponent = null;

    // @property(cc.Node)
    // toggleBg: cc.Node = null;

    // @property(cc.Node)
    // ToggleContainer: cc.Node = null;

    @property(cc.Button)
    reconnectBtn : cc.Button = null;

    // @property(cc.Sprite)
    // toggleBgList: cc.Sprite[] = [];

    // @property(SpriteFrameHolder)
    // iconSprFrameHolder: SpriteFrameHolder = null;

    @property(SpriteFrameHolder)
    iconSprFrameHolder2: SpriteFrameHolder = null;
    // @property(cc.Node)
    // special: cc.Node = null;

    @property(cc.Sprite)
    private specialBg: cc.Sprite = null;

    // @property(cc.Node)
    // private frameNode : cc.Node = null;

    pingColor = [new cc.Color(255, 0, 0, 255), new cc.Color(255, 255, 0, 255), new cc.Color(195, 184, 0, 255), new cc.Color(123, 185, 59, 255), new cc.Color(43, 237, 80, 255)]

    roomTypeIndex: { [key: number]: string } = {};
    cacheJackPot = {};
    selectToggle = -1;
    ret : [ProtoHallServerNotify.IRoomData[]] = [[]];
    select = -1;
    // toggleBGSize = null;
    // toggleBGPosition = null;
    toggleActiveLength = 0
    //<comboType,sceneIndex >
    sceneIndexMap : Map<number,number> = new Map<number,number>();
    toggleSelect = -1;

    setInfo(data: IUserData) {
        //cc.log("setInfo", data)
        this.playerInfo.avatar.show(true, data.id)
        // this.playerInfo.id.string = "ID:" + data.idShow
        // this.playerInfo.avatar.spriteFrame = data.avatarSprite
    }

    setGold(data: IUserCurrencyData) {
        this.playerInfo.avatar.showCoinBalance(true)
        this.playerInfo.avatar.refreshCoinBalance(data.chip)
    }
    showTweenNode() {
        this.top.active = true;
        this.rightNode.active = true;
    }

    reset() {
        //cc.log("进入到reset111");
        this.roomTypeIndex = {};
        this.cacheJackPot = {};
        this.minLimit.string = LanguageManager.t("session_NoLimit");
        this.jackpot.string = "0";
        //this.selectToggle = 0;
        this.ret = [[]];
        this.m_list = [];
        this.itemList = [];
        //this.roomTypeMap.clear();

        //
    }
    onLoad() {
        //cc.log("oLoad---------goldentrance----------:", AppData.gameName);

        // this.toggleList.forEach(Element => {
        //     Element.node.on("click", function () {
        //         Utility.playButtonSound();
        //     })
        // });
        // this.toggleBGSize = this.toggleBg.getContentSize();
        // this.toggleBGPosition = this.toggleBg.position;
    }

    onShow(args0){
        super.onShow(args0);

        this.reconnectBtn.node.active = AppData.testMode;
        if(args0 == "HallShowGoldEntrance"){
            this.bgNode.opacity = 0
            this.bgNode.runAction(cc.fadeIn(0.3))
        }
    }

    on_item_select(data: any, index: number) {
        //cc.log(data, index);
    }
    initializationTitleSetting() {
        switch (AppData.gameName) {
            case "TM_LHD":
                this.titleList.forEach(title=>{             
                    title.active = title.name == "title1" ? true : false;
                });
                break;
            case "TM_TB":
                this.titleList.forEach(title=>{             
                    title.active = title.name == "title2" ? true : false;
                });
                break;
            case "TM_YXX":
                this.titleList.forEach(title=>{             
                    title.active = title.name == "title3" ? true : false;
                });
                break;
            case "TM_CP":
                this.titleList.forEach(title=>{             
                    title.active = title.name == "title4" ? true : false;
                });
                break;
            case "TM_BJL":
                this.titleList.forEach(title=>{             
                    title.active = title.name == "title5" ? true : false;
                });
                break;    
        }
        this.changeTag(AppData.gameName);
    }
    updateJackPot(roomTypeList) {
        this.cacheJackPot = roomTypeList;
    }


    updateShow(roomMap : Map<number, Map<number,ProtoHallServerNotify.IRoomData> >, useAPIData = false) {
        cc.warn("updateShow roomMap ", roomMap);

        
        //this.frameNode.active = true;

        //this.ret = []
        // var test =0;
        // for (let key in roomMap) {
        //     //var value = roomList[key]
        //     // test++;
        //     roomMap[key].apiData = useAPIData
        //     if (roomMap.hasOwnProperty(key)) {
   
        //         var number1 = roomMap[key].roomType == "10" ? 0 : Number(roomMap[key].roomType);
        //         if (this.toggleActiveLength == 1) {
        //             number1 = roomMap[key].roomType == "1" ? 0 : Number(roomMap[key].roomType);
        //         }
        //         var idx = useAPIData ? Number(roomMap[key].goldType) : number1
        //         if (this.ret[idx] == undefined || this.ret[idx] == null) {
        //             this.ret[idx] = []
        //         }
        //         this.ret[idx].push(roomMap[key]);

        //     }
        // }

        //判断有无芒果场

        this.ret  = [[]];
 
        roomMap.forEach((value,roomType,map)=>{
            value.forEach(roomData =>{
                let index = this.getSceneIndex(roomType);
                if (!this.ret[index]) {
                    this.ret[index] = [];
                }
                this.ret[index].push(roomData);
            });                
        });
        
        //cc.log("this.m_list",this.m_list);
        // cc.log("test:",test);
        // if (this.toggleList[this.selectToggle]) {
        //     this.toggleList[this.selectToggle].check();
        // }


        //this.m_list = [];
        cc.log("this.selectToggle:", this.selectToggle);
        this.refreshRoadMap(this.selectToggle);
    }

    update_list_item(item: cc.Node, data: ProtoHallServerNotify.IRoomData, index: number, item_intact?: any): void {
        this.itemList[data.roomId] = { item: item_intact, data: data }
        item.active = (data != null && !data.closed)
        if (!item.active) {
            // cc.log(item.active, "update_list_item^^^^^^update_list_item^^^^^^", data.roomType, index)
            let accountType = JSON.parse(data.extJson).accountType;
            this.m_list[this.getSceneIndex(data.roomType,accountType)].remove_data(index, 1)

            this.itemList[data.roomId] = { item: null, data: data }
            return
        }
        let goldRoomItem = item.getComponent(GoldRoomItem)
        goldRoomItem.setData(data)
    }
    update_list_item_0(item: cc.Node, data: any, index: number, item_intact?: any): void {

        this.itemList[data.roomId] = { item: item_intact, data: data }

        item.active = (data != null && !data.closed)
        if (!item.active) {
            // cc.log(item.active, "update_list_item_0^^^^^^update_list_item^^^^^^", data.roomType, index)
            let accountType = JSON.parse(data.extJson).accountType;
            this.m_list[this.getSceneIndex(data.roomType,accountType)].remove_data(index, 1)

            this.itemList[data.roomId] = { item: null, data: data }
            return
        }
        let goldRoomItem = item.getComponent(GoldRoomItem)
        goldRoomItem.setItemMapData(data)
        
    }

    changeTag(gameName: string) {
        this.marquee.tag = gameName;
        this.marquee.showMarquee(false);
        cc.log("this.marquee.tag:", this.marquee.tag);
    }
    //拆出一局开出的结果  服务器给的值如“123” 表示这一局开出的结果为  1， 2, 3
    disposeData(data) {
        let ret: number[] = []
        let dataString = String(data)
        ret[0] = Number(dataString[0])
        ret[1] = Number(dataString[1])
        ret[2] = Number(dataString[2])
        return ret
    }
    FillListView(i: number) {
        //cc.log("index:",index);

        let itemPrefab = null;
        let itemUpdateFunc = null;
        let gapY = 0;
        if (AppData.gameName == "TM_LHD") {
            itemPrefab = this.prefab[0];
            itemUpdateFunc = this.update_list_item;
            gapY = 3;
        }else if(AppData.gameName == "TM_BJL"){
            itemPrefab = this.prefab[2];
            itemUpdateFunc = this.update_list_item;
            gapY = 3;
        }else{
            itemPrefab = this.prefab[1];
            itemUpdateFunc = this.update_list_item_0;
            gapY = 10;
        }

        let list: ListView = new ListView({
            scrollview: this.scrollview[i],
            view: this.view[i],
            content: this.content[i],
            item_prefab:  itemPrefab,
            cb_host: this,
            item_update_func: itemUpdateFunc,
            select_cb: this.on_item_select,
            column: 1,
            row: 1,
            gap_y: gapY,
            direction: ListViewDir.Vertical,
        });
        this.m_list[i] = list;
    }
    //刷新单条room显示
    refreshItem(data) {
        cc.log(" refreshItem ",data);
        cc.log(" ret " , this.ret);
        if (this.itemList[data.roomId]) {
            let item = this.itemList[data.roomId].item
            if (item && item.node) {
                let goldRoomItem : GoldRoomItem = item.node.getComponent(GoldRoomItem)

                this.itemList[data.roomId] = { item: item, data: data }

                item.node.active = (data != null && !data.closed)
                if (!item.node.active) {
                    let accountType = JSON.parse(data.extJson).accountType;
                    let idx = this.m_list[this.getSceneIndex(data.roomType,accountType)].items.indexOf(item)
                    // cc.log(item.node.active, "^^^^^^update_list_item^^^^^^", data.roomType, idx)
                    this.m_list[this.getSceneIndex(data.roomType)].remove_data(idx, 1)
                    this.itemList[data.roomId] = { item: null, data: data }                    
                }
                //cc.log("this.itemList[data.roomId].data:",this.itemList[data.roomId].data);
                else if (data.gameId == "TM_LHD" || data.gameId == "TM_BJL") {
                    //cc.log("刷新龙虎斗单个房间数据",this.itemList[data.roomId].data)
                    goldRoomItem.setData(this.itemList[data.roomId].data);
                }
                else {
                    //cc.log("刷新鱼虾蟹单个房间数据",this.itemList[data.roomId].data);
                    goldRoomItem.setItemMapData(this.itemList[data.roomId].data)
                }
                // else if (this.itemList[data.roomId].data.gameId == "TM_TB" || 
                //          this.itemList[data.roomId].data.gameId == "TM_CP") {
                //     goldRoomItem.setItemMapData(this.itemList[data.roomId].data, 1)
                // }
            }

        }
    }


    //增加一条
    addItem(sceneIndex: number, data: any) {
        cc.warn(" addItem " ,sceneIndex , 
                " roomid " , data.roomId , 
                " roomtype " , data.roomType  ,
                " roomIx" , data.roomIx);
                
        if (!this.ret[sceneIndex]) {
            this.ret[sceneIndex] = []
        }

        this.ret[sceneIndex].push(data);
        this.ret[sceneIndex].sort(function (a, b) {
            return a.roomIx - b.roomIx
        });      
                 
        if (this.m_list[sceneIndex]) {
            //默认放在最后
            var insert = this.ret[sceneIndex].length - 1;         
            for (let index = 0; index < this.ret[sceneIndex].length; index++) {
                const element = this.ret[sceneIndex][index];
                if (data.roomId == element.roomId) {
                    insert = index;                    
                    break;
                }
            }        
            cc.log(`insert ${insert}`);
            this.m_list[sceneIndex].insert_data(insert,data);        
        }else{
            //表示该场次还没有房间
            this.refreshRoadMap(sceneIndex);
        }
    }

    //删除
    deleteItem(sceneIndex: number, data: any) {

        cc.warn(" deleteItem " ,sceneIndex , 
                " roomid " , data.roomId , 
                " roomtype " , data.roomType  ,
                " roomIx" , data.roomIx);
       
        cc.log(" ret :",this.ret);

        if(!this.ret[sceneIndex])
        {            
            cc.warn(" deleteItem => can not find sceneIndex " + sceneIndex);
            return;
        }
        this.ret[sceneIndex] = this.ret[sceneIndex].filter(item => item.roomId !== data.roomId);
      
        if (this.m_list[sceneIndex]) {
            var deleteIx = -1;
            let items = this.m_list[sceneIndex].items;
            for (let i = 0; i < items.length; i++) {
                let dt = items[i].data;
                if (dt.roomId == data.roomId) {
                    deleteIx = i;
                    break;
                }
            }
            if (deleteIx != -1) {
                this.m_list[sceneIndex].remove_data(deleteIx, 1);
            }
            else {
                cc.log("房间列表中不存在对应数据 无法删除:", this.m_list[sceneIndex], data);
            }
        }
        else {
            cc.log("对应场次的房间列表", this.m_list[sceneIndex], data);
        }
    }


    refreshJackPot() {
        var xindex = this.selectToggle;

        var rindex = this.roomTypeIndex[xindex]
        if (this.cacheJackPot.hasOwnProperty(rindex)) {
            //cc.log("minJoinCoin:",this.cacheJackPot[rindex]["minJoinCoin"])
            if (this.minLimit.string != this.cacheJackPot[rindex]["minJoinCoin"]) {
                if (this.cacheJackPot[rindex]["minJoinCoin"] != 0) {
                    this.minLimit.string = this.cacheJackPot[rindex]["minJoinCoin"];
                }
                else {
                    this.minLimit.string = LanguageManager.t("session_NoLimit");
                }
            }
            if (this.jackpot.string != this.cacheJackPot[rindex]["jackpot"]) {
                this.jackpot.string = this.cacheJackPot[rindex]["jackpot"];
            }
        }
        else {
            this.minLimit.string = LanguageManager.t("session_NoLimit");
            this.jackpot.string = "0";
        }
    }
    refreshRoadMap(sceneIndex: number) {

        if (sceneIndex == -1 || !this.ret[sceneIndex]) {
            return;
        }
        if (!this.m_list[sceneIndex]) {
            //cc.log("1111this.m_list:",this.m_list);
            //cc.log("清理掉之前的item 重新设置listView");
            // if (this.m_list[sceneIndex]) {
            //     if (this.m_list[sceneIndex].items) {
            //         this.m_list[sceneIndex].remove_data(0, this.m_list[sceneIndex].items.length);
            //     }
            // }
            cc.log("FillListView:", sceneIndex);
            this.FillListView(sceneIndex);
            //cc.log("2222this.m_list:",this.m_list);
        }
        cc.log(" roomTypeIndex",this.roomTypeIndex);
        if (!this.roomTypeIndex.hasOwnProperty(sceneIndex)) {
            
            let roomDataList = this.ret[sceneIndex];
            if (!roomDataList) {
                cc.warn("有空的场次：", sceneIndex, roomDataList);
                return;
            }
            if (roomDataList.length > 0) {
                let accountType = JSON.parse(roomDataList[0].extJson).accountType;
                
                this.roomTypeIndex[sceneIndex] = this.getSceneIndex(roomDataList[0].roomType,accountType).toString();
                this.refreshJackPot();
            }
            if (this.m_list[sceneIndex]) {
                roomDataList.sort(function (a, b) {
                    return a.roomIx - b.roomIx
                })
                cc.log("roomDataList:", roomDataList);
                this.m_list[sceneIndex].set_data(roomDataList);
            }
            else {
                cc.log("xxxxxxxxxxxxxxxxxxxxxxxxxxx出错了#########################");
            }
        }
    }
    setSelectToggle(temp: number, toggleLength ?: number) {
        cc.log("setSelectToggle:", temp);
        //
        this.selectToggle = temp;
        this.toggleActiveLength = toggleLength

        // if (this.toggleList[this.selectToggle]) {
        //     this.toggleList[this.selectToggle].check();
            
        // }
        

    }

    setGameGoldsTypeList(temp: number) {

    }

    showSpecialBg(show : boolean){

        //cc.warn(" showSpecialBg ", show);
        this.specialBg.node.parent.active = show;  
        if (show) {
            this.specialBg.spriteFrame = this.iconSprFrameHolder2.getSpriteFrameByKey(AppData.gameName);   
        }                
    }
    
    checkSelectToggle(temp: number) {
        // let self = this;
        // cc.log("temp:", temp);
        // cc.log("this.toggleList:",this.toggleList)
        // cc.log("this.toggleList[,temp]:", this.toggleList[temp], self.toggleList[temp]);
        // if (this.toggleList[temp]) {
        //     this.toggleList[temp].check();
        //     this.toggleList[temp].isChecked = true;
        // }
    }
    ToggleChange1(toggleSelf, customEventData) {
        this.toggleChange(customEventData);
    }

    ToggleChange2(toggleSelf, customEventData) {        
        this.toggleChange(customEventData);
    }

    private toggleChange(customEventData){     
        // this.mango.active = false;
        // this.chip.active = true;
        //this.coinDes.string = LanguageManager.t("Public_Mango");
        // this.coinDes.string = LanguageManager.t("Public_Chip");

        this.selectToggle = Number(customEventData);
        this.refreshRoadMap(this.selectToggle);
        this.refreshJackPot();
        this.toggleSelect = this.selectToggle;

        this.eventDispatch("on_goldentrance_toggle",this.selectToggle);      
    }

    public checkTog(index : number){

        // if(this.toggleList.length > index){
        //     this.toggleList[index].check()
        // }else if(this.toggleList.length > 0){
        //     this.toggleList[0].check();
        // }
    }
    
    public updateCoinIcon(accountType : number){
        this.mango.active = false;
        this.chip.active = true;
        this.coinDes.string = LanguageManager.t("Public_Chip");
    }

    setSelect(i: number) {
        this.select = i;
    }


    public syncSceneMap(map : Map<number,number>){
        
        this.sceneIndexMap = map;
    }

    /**
     * 场次的index
     */
    private getSceneIndex(roomType : any, accountType:number = 0  ){

        let comboType = accountType * 100 +  Number(roomType) ;
        return this.sceneIndexMap.get(comboType);
    }
    
    
    clearitem() {
        cc.warn(" clearitem ");
        this.m_list.forEach((element) => {
            // if (element && element.items) {
            //     element.remove_data(0, element.items.length);
            // }         
            if (element) {
                element.destroyListView();
            }
        });

        

        this.m_list = [];
        this.ret = [[]];    
        //this.roomTypeMap.clear();    
    }

    /**
     * 清空场次相关内容
     * @param comboType accountType * 100 + roomType
     */
    clearSceneItem(comboType : number){
 
        let sceneIndex =  this.getSceneIndex(comboType);    

        let listView = this.m_list[sceneIndex];
        if (listView) {
                        
            listView.remove_data(0,listView.items.length);
            this.m_list[sceneIndex] = null;
        }

        if(!this.ret[sceneIndex]){

            this.ret[sceneIndex] = [];
        }
        
        if (sceneIndex) {
            
            this.sceneIndexMap.delete(comboType);
        }

        if (this.roomTypeIndex.hasOwnProperty(sceneIndex)) {
            
            this.roomTypeIndex[sceneIndex] = null;
        }
        
    }

    clearTittle(){

        // for (let index = 0; index < this.toggleList.length; index++) {
            
        //     this.toggleList[index].node.active = false;
        // }    
        // this.toggleBg.active = false;
        // this.specialBg.node.parent.active = false;
        this.toggleSelect = -1;
    }

    setToggleBgSize(x_size: number, x_position: number, x: number) {
        // this.toggleBg.setContentSize(x_size, this.toggleBGSize.height);
        // this.toggleBg.position = cc.v2(x_position, this.toggleBGPosition.y);
        // this.ToggleContainer.position = cc.v2(x, 224.5);
        // this.toggleBg.active = true;
    }
    onDisable() {
        //this.frameNode.active = false;
        //this.specialBg.node.parent.active = false;
        //this.roomTypeIndex = {};
        //this.cacheJackPot = {};
        //this.minLimit.string = LanguageManager.t("session_NoLimit");
        //this.jackpot.string = "0";
        //this.ret = [];
        //this.roomTypeMap.clear();

        //this.toggleSelect = -1;
        //this.toggleBg.active = false;
        // for (let index = 0; index < this.toggleList.length; index++) {
            
        //     this.toggleList[index].node.active = false;
        // }        
    }
}
